/**
 * SectionHeading — the shared premium section header used across the
 * redesigned homepage (home-v3 layout language): a capsule eyebrow badge,
 * a large tracking-tight H2, and an optional lead paragraph.
 */
export default function SectionHeading({
  eyebrow,
  icon: Icon,
  title,
  description,
  align = "left",
  eyebrowColor,
  testid,
  animate,
  className = "",
}) {
  const isCenter = align === "center";
  return (
    <div
      data-testid={testid}
      data-animate={animate}
      className={`${isCenter ? "mx-auto text-center max-w-2xl" : "max-w-2xl"} ${className}`}
    >
      {eyebrow && (
        <span
          className="eyebrow-cap"
          style={eyebrowColor ? { color: eyebrowColor } : undefined}
        >
          {Icon && <Icon className="w-3.5 h-3.5" strokeWidth={2.4} />}
          {eyebrow}
        </span>
      )}
      <h2 className="mt-4 text-2xl sm:text-3xl lg:text-[40px] font-extrabold tracking-[-0.03em] text-ink leading-[1.1]">
        {title}
      </h2>
      {description && (
        <p className={`mt-3.5 text-[15px] sm:text-base text-ink-soft/85 leading-relaxed ${isCenter ? "mx-auto" : ""} max-w-xl`}>
          {description}
        </p>
      )}
    </div>
  );
}
